import { render, staticRenderFns } from "./mainrightclick.vue?vue&type=template&id=7908f712&"
import script from "./mainrightclick.vue?vue&type=script&lang=js&"
export * from "./mainrightclick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports